// extracted by mini-css-extract-plugin
export default {"pill":"DictionaryPill_pill__tQ55+"};